
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solution-for-micro-entrepreneur",
      function () {
        return require("private-next-pages/solution-for-micro-entrepreneur.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solution-for-micro-entrepreneur"])
      });
    }
  